export default () => {
  const icons = document.querySelectorAll('.icon__icon');

  if(icons) {
    icons.forEach((icon, index) => {
      icon.style.animationDelay = `${index * 0.5}s`;
      icon.classList.add('icon__animate');
  });
  }
}